<template>
  <div :class="[$style.__chat]">
    <div :class="[$style.__chat__content, !online ? [$style.__expand] : '']">
      <ul
        :class="[
          $style.__chat__message,
          status.errorSend ? [$style.__error] : '',
        ]"
        :id="'chat__message'"
        ref="chatContent"
        class="messages"
        v-chat-scroll="{ always: false, smooth: true, scrollonremoved: true }"
      >
        <li
          :class="[$style.__revert, $style.__welcome, 'message']"
          v-if="online && messages.length == 0 && history.ready == true"
        >
          <div :class="['row-livechat']">
            <div :class="[$style.__chat__left, 'col-12']">
              <div :class="[$style.__chat__item]">
                <h5
                  v-html="
                    $t('messages.hello', {
                      gender: gender,
                      name: $cookies.get('fpt_livechat').name,
                    })
                  "
                ></h5>
                {{ $t("messages.intro3") }}
              </div>
            </div>
          </div>
        </li>
        <li
          v-for="(item, id) in messages"
          v-bind:key="id"
          :class="[
            item.revert ? [$style.__revert] : [$style.__normal],
            'message',
          ]"
        >
          <div :class="['row-livechat']" v-if="item.revert">
            <div :class="[$style.__chat__avatar, 'col-2']">
              <img :src="avatar" alt="" />
            </div>

            <div :class="[$style.__chat__left, 'col-9']">
              <div :class="[$style.__chat__time]">
                {{ item.agent.name }}, {{ item.time }}
                <div :class="[$style.__prefix]">
                  {{ $t("messages.agent.prefix") }}
                </div>
              </div>
              <div
                :class="[
                  $style.__chat__item,
                  item.type == 'image' ? [$style.__image__box] : '',
                ]"
              >
                <MessageRender :message="item" />
              </div>
            </div>
          </div>
          <div v-else>
            <div :class="[$style.__chat__time]">{{ item.time }}</div>
            <div
              :class="[
                $style.__chat__item,
                item.type == 'image' ? [$style.__image__box] : '',
              ]"
            >
              <div v-html="item.content"></div>
            </div>
          </div>
        </li>
      </ul>
      <div :class="[$style.__success__message]" v-if="status.success">
        <img :src="icon.success" />
        <div :class="[$style.__text]">
          {{ $t("messages.send.success") }}
        </div>
      </div>
      <div :class="[$style.__error__message]" v-if="status.errorSend">
        <div :class="[$style.__text]">
          <span :class="['material-icons']"> warning </span>
          {{ $t("messages.send.fast") }}
        </div>
      </div>
      <div :class="[$style.__error__message]" v-if="status.errorSendImage">
        <div :class="[$style.__text]">
          <span :class="['material-icons']"> warning </span>
          {{ $t("messages.send.imageError") }}
        </div>
      </div>
    </div>
    <div :class="[$style.__chat__type]">
      <div :class="[$style.__chat__input]">
        <form
          @submit="sendMessage"
          enctype="multipart/form-data"
          v-if="agentCloseChatVar == false"
        >
          <ImageUpload
            :imagesData="imagesData"
            @parentRemoveImage="handleRemoveImage"
          ></ImageUpload>
          <FileUpload
            :fileData="fileData"
            @parentCallRemoveFile="handleRemoveFile"
          ></FileUpload>
          <div :class="[$style.__chat__type__container]">
            <textarea
              v-model="msg"
              :class="[$style.__chat__area]"
              :placeholder="[this.$t('input.type')]"
              @keydown.enter.exact.prevent
              @keyup.enter.exact="sendMessage"
              @keydown.8.exact="handerBackspace"
              @keydown.46.exact="handerBackspace"
              @paste="onPasteClipboard"
              @keyup="checkWhiteSpace"
            >
            </textarea>

            <button type="submit" :class="[$style.__btn__send]" title="Send">
              <i class="material-icons">send</i>
            </button>
          </div>
          <input
            type="file"
            id="file"
            ref="uploadImageFile"
            class="custom-file-input d-none"
            accept="image/x-png,image/gif,image/jpeg"
            @change="imagePreview"
          />
          <input
            type="file"
            id="file"
            ref="uploadAttachFile"
            class="custom-file-input d-none"
            accept="
                            application/msword, 
                            text/plain, 
                            application/pdf,
                            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                            video/mp4,
                            video/x-m4v,
                            vide/3gpp
                        "
            @change="attachFilePreview"
          />
        </form>
        <textarea
          :class="[$style.__chat__area, $style.__chat__close]"
          :placeholder="[this.$t('input.close')]"
          disabled="disabled"
          v-if="agentCloseChatVar == true"
        >
        </textarea>
      </div>
    </div>
    <div :class="[$style.__chat__footer]">
      <div :class="[$style.__chat__action]">
        <div :class="[$style.__icon__camera]" v-if="agentCloseChatVar == false">
          <a
            @click="uploadImage"
            :class="['material-icons', $style.__icon]"
            v-if="online == true"
            >camera_alt</a
          >
        </div>
        <div :class="[$style.__icon__attach]" v-if="agentCloseChatVar == false">
          <a
            @click="attachFile"
            :class="['material-icons', $style.__icon]"
            v-if="online == true"
            >attachment</a
          >
        </div>
        <div :class="[$style.__icon__setting]">
          <a
            :class="[
              'material-icons',
              $style.__icon,
              isSetting ? [$style.__active] : '',
            ]"
            @click="setting"
            >settings</a
          >
          <ul
            :class="[
              $style.__dropup__custom,
              isSetting ? [$style.__active] : '',
              sso == null ? [$style.__not__sso] : '',
              agentCloseChatVar == true ? [$style.__not__sso] : '',
            ]"
            aria-labelledby="notify-box"
          >
            <li v-if="sso != null && agentCloseChatVar == false">
              <a @click="rename"
                ><span :class="['material-icons', $style.__icon]"
                  >person_outline</span
                ><span>{{ $t("chat.rename") }}</span></a
              >
            </li>
            <li>
              <a @click="confirmExit"
                ><span :class="['material-icons', $style.__icon]"
                  >exit_to_app</span
                ><span>{{ $t("chat.end") }}</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Exit
      :cfmExit.sync="cfmExit"
      :room="room"
      :token="token"
      @exitChat="closeChatHandle"
      @parentcfmExit="cfmExit = $event"
    ></Exit>
    <Loading :displayLoading.sync="displayLoading"></Loading>
  </div>
</template>

<script>
import Chathub from "@/apis/chathub";
import Socket from "@/sockets/Socket";
import VueChatScroll from "vue-chat-scroll";
import Vue from "vue";
import moment from "moment";
import VueCookies from "vue-cookies";
import Exit from "../blocks/Exit";
import ImageUpload from "../blocks/ImageUpload";
import FileUpload from "../blocks/FileUpload";
import Validator from "@/functions/Validator";
import Loading from "../blocks/Loading";
import MessageRender from "../blocks/MessageRender";
import EventBus from "@/functions/EventBus";

Vue.use(VueCookies);
Vue.use(VueChatScroll);

let chathubObject = new Chathub();
let validatorObject = new Validator();

export default {
  props: {
    isClose: {
      type: Boolean,
    },
  },
  data() {
    return {
      avatar:
        process.env.NODE_ENV == "local"
          ? require("@/medias/images/avatar/noavatar.png")
          : process.env.VUE_APP_STORAGE + "/vue/img/noavatar.png",
      icon: {
        success:
          process.env.NODE_ENV == "local"
            ? require("@/medias/images/icon/success.png")
            : process.env.VUE_APP_STORAGE + "/vue/img/icon/success.png",
      },
      status: {
        success: false,
        errorSend: false,
        errorSendImage: false,
      },
      msg: "",
      token: "",
      room: "",
      messages: [],
      count: 0,
      isSetting: false,
      cfmExit: false,
      online: true,
      imagesData: [],
      fileData: [],
      sso: [],
      history: {
        ready: false,
      },
      agentInfo: {
        name: "",
      },
      gender: "",
      displayLoading: false,
      agentCloseChatVar: false,
      userOnlineStatus: navigator.onLine,
    };
  },

  watch: {
    userOnlineStatus(v) {
      if (v) {
        this.$router.push({ path: "/" });
      }
    },
  },

  components: {
    Exit,
    ImageUpload,
    FileUpload,
    Loading,
    MessageRender,
  },

  methods: {
    sendMessage: function (event) {
      if (this.online) {
        if (this.msg.trim().length > 0) {
          this.mockMessage();
          var resultSendMessage = chathubObject.sendMessage(
            this.token,
            this.room,
            this.msg
          );
          resultSendMessage
            .then((response) => {
              if (response.data.success) {
                var msg = response.data.message.msg;
                var time = this.convertTime(response.data.message.ts);
                if (this.checkImage(msg)) {
                  msg = this.createImage(msg, this.$t("img.alt"));
                }
                this.messages.push({
                  content: msg,
                  time: time,
                });
                this.msg = "";
              }
            })
            .catch((error) => {
              var that = this;
              this.status.errorSend = true;
              setTimeout(function () {
                that.status.errorSend = false;
              }, 3000);
            });
        }
      } else {
        this.sendMessageOffline(event);
      }

      if (this.imagesData.length > 0) {
        this.displayLoading = true;
        var that = this;
        this.imagesData.forEach(function (item, index) {
          var form = new FormData();
          chathubObject
            .uploadFile(item.object, that.room, that.token)
            .then((response) => {
              if (response.data.success == true) {
                var ImageUrl = that.createImage(
                  window.URL.createObjectURL(item.object),
                  "preview"
                );
                that.displayLoading = false;
                that.messages.push({
                  content: ImageUrl,
                  type: "image",
                  time: that.convertTime(moment().format()),
                });
                that.imagesData = [];
                that.$refs.uploadImageFile.value = "";
              }
            })
            .catch((error) => {
              that.status.errorSendImage = true;
              that.displayLoading = false;
              setTimeout(function () {
                that.status.errorSendImage = false;
              }, 3000);
            });
        });
      }

      if (this.fileData.length > 0) {
        var that = this;
        this.displayLoading = true;
        this.fileData.forEach(function (item, index) {
          var form = new FormData();
          chathubObject
            .uploadFile(item.object, that.room, that.token)
            .then((response) => {
              if (response.data.success == true) {
                var createFile = that.createFile(item.object.name, item.url);
                that.displayLoading = false;
                that.messages.push({
                  content: createFile,
                  time: that.convertTime(moment().format()),
                });

                that.fileData = [];
                that.$refs.uploadAttachFile.value = "";
              }
            })
            .catch((error) => {
              that.status.errorSendImage = true;
              that.displayLoading = false;
              setTimeout(function () {
                that.status.errorSendImage = false;
              }, 3000);
            });
        });
      }

      event.preventDefault();
    },
    mockMessage() {
      // this.messages.push({
      //     content: this.msg,
      //     time: Date.now()
      // });
      console.log("Mock receive message");
      if (this.msg.trim() == "carousel") {
        this.messages.push({
          revert: true,
          agent: {
            name: "Binh",
          },
          rid: "abcdkaelel",
          channel: "facebook",
          message: {
            message: {
              attachment: {
                type: "template",
                payload: {
                  template_type: "generic",
                  elements: [
                    {
                      title: "Thông tin dịch vụ",
                      image_url:
                        "https://cdn-static-v3.fpt.ai/upload/eccf619afb2a088ee4bbe7dac083e153/3c0ff249d3c8bb5bdf9d27955a3cca0c.jpg",
                      subtitle: "   ",
                      buttons: [
                        {
                          type: "web_url",
                          url:
                            "https://fpt.vn/vi/khach-hang-ca-nhan/san-pham-dich-vu/internet-fpt/ftth.html",
                          title: "Internet FPT",
                        },
                        {
                          type: "web_url",
                          url:
                            "https://fpt.vn/vi/khach-hang-ca-nhan/san-pham-dich-vu/truyen-hinh-fpt/goi-co-ban.html",
                          title: "Truyền hình FPT",
                        },
                        {
                          type: "web_url",
                          url:
                            "https://fpt.vn/vi/khach-hang-ca-nhan/san-pham-dich-vu/dich-vu-online/fpt-play.html",
                          title: "Dịch vụ Online",
                        },
                      ],
                    },
                    {
                      title: "Đăng ký mới",
                      image_url:
                        "https://cdn-static-v3.fpt.ai/upload/eccf619afb2a088ee4bbe7dac083e153/501e2083a010a5a27b06f510efc047f6.jpg",
                      subtitle: "  ",
                      buttons: [
                        {
                          type: "web_url",
                          url: "https://fpt.vn/shop",
                          title: "Đăng ký trực tuyến",
                        },
                      ],
                    },
                    {
                      title: "Hỗ trợ kỹ thuật",
                      image_url:
                        "https://cdn-static-v3.fpt.ai/upload/eccf619afb2a088ee4bbe7dac083e153/b5dc363aff0beb5456e0c21687553a41.jpg",
                      subtitle: "     ",
                      buttons: [
                        {
                          type: "postback",
                          title: "Hướng dẫn cài đặt",
                          payload: "Hướng dẫn cài đặt chung#",
                        },
                        {
                          type: "postback",
                          title: "Xử lý sự cố",
                          payload: "Hướng dân xử lý sự cố chung#",
                        },
                      ],
                    },
                    {
                      title: "Yêu cầu khác",
                      image_url:
                        "https://cdn-static-v3.fpt.ai/upload/eccf619afb2a088ee4bbe7dac083e153/dd3f247c03bb9e7f41d8a4a0c50fe39c.jpg",
                      subtitle:
                        "Hãy trao đổi với chúng tôi để FPT Telecom hiểu rõ hơn yêu cầu của Quý khách.",
                      buttons: [
                        {
                          type: "postback",
                          title: "Gặp nhân viên hỗ trợ",
                          payload: "Yêu cầu gặp nhân viên#",
                        },
                      ],
                    },
                  ],
                },
              },
            },
          },
        });
      } else if (this.msg.trim() == "text") {
        this.messages.push({
          revert: true,
          agent: {
            name: "Binh",
          },
          rid: "abcdkaelel",
          channel: "facebook",
          message: {
            message: {
              text: "facebook",
            },
          },
        });
      } else if (this.msg.trim() == "image") {
        console.log(this.msg.trim());
        this.messages.push({
          revert: true,
          agent: {
            name: "Binh",
          },
          rid: "BG9ADvr2xg4hzLwYB",
          channel: "facebook",
          message: {
            message: {
              attachment: {
                type: "image",
                payload: {
                  url:
                    "https://cdn-static-v3.fpt.ai/upload/eccf619afb2a088ee4bbe7dac083e153/3c0ff249d3c8bb5bdf9d27955a3cca0c.jpg",
                },
              },
            },
          },
        });
      } else if (this.msg.trim() == "quickrep") {
        this.messages.push({
          revert: true,
          agent: {
            name: "Binh",
          },
          rid: "abcdkaelel",
          channel: "facebook",
          message: {
            messaging_type: "RESPONSE",
            message: {
              text: "Chọn 1 trong 3 nut",
              quick_replies: [
                {
                  content_type: "text",
                  title: "Welcom",
                  payload: "Ai tạo ra bot#",
                },
                {
                  content_type: "text",
                  title: "Hello",
                  payload: "Chê bai BOT#",
                },
                {
                  content_type: "text",
                  title: "alo",
                  payload: "+84971008365",
                },
              ],
            },
          },
        });
      } else if (this.msg.trim() == "button") {
        this.messages.push({
          revert: true,
          agent: {
            name: "Binh",
          },
          rid: "abcdkaelel",
          channel: "facebook",
          message: {
            message: {
              attachment: {
                type: "template",
                payload: {
                  template_type: "button",
                  text: "facebook",
                  buttons: [
                    {
                      type: "postback",
                      title: "ad",
                      payload: "Ai tạo ra bot#YWFhYQ==",
                    },
                    {
                      type: "web_url",
                      url: "https://example.com",
                      title: "aff",
                    },
                    {
                      type: "phone_number",
                      title: "alo",
                      payload: "+84971008365",
                    },
                  ],
                },
              },
            },
          },
        });
      }
    },
    sendMessageOffline: function (event) {
      var name = this.$route.query.name;
      var email = this.$route.query.email;
      var message = this.msg;
      if (message.trim().length > 0) {
        var resultSendMessage = chathubObject.sendOfflineMessage(
          name,
          email,
          message
        );
        resultSendMessage
          .then((response) => {
            if (response.data.success) {
              var time = this.convertTime(moment().format());

              this.messages.push({
                content: message,
                time: time,
              });
              this.status.success = true;
            }
          })
          .catch((error) => {
            var that = this;
            this.status.errorSend = true;
            setTimeout(function () {
              that.status.errorSend = false;
            }, 3000);
          });
        this.msg = "";
      }
    },

    handleMessage: function (event) {
      var objectMessage = JSON.parse(event);
      var type = null;
      if (objectMessage.msg == "changed") {
        if (objectMessage.fields.eventName == this.room) {
          var username = objectMessage.fields.args[0].u.username;
          if (username.indexOf("guest")) {
            if (!objectMessage.fields.args[0].t) {
              var inbox = objectMessage.fields.args[0].msg;
              var time = this.convertTime(
                objectMessage.fields.args[0].ts.$date,
                false
              );
              if (objectMessage.fields.args[0].file) {
                var file = objectMessage.fields.args[0].file;
                // var img = new Image();
                var img = this.createImage(
                  chathubObject.getImageFile(file._id, file.name),
                  this.$t("img.alt")
                );
                inbox = img;
                type = "image";
              } else {
                type = null;
              }
              if (inbox != null && inbox != "") {
                this.messages.push({
                  content: inbox,
                  revert: true,
                  time: time,
                  type: type,
                  agent: {
                    name: objectMessage.fields.args[0].u.name,
                  },
                });
              }
            }

            if (objectMessage.fields.args[0].t == "livechat-close") {
              this.agentCloseChat();
            }
          }
        }
      }
    },

    createImage: function (src, title) {
      title = title.replace(/"/g, "&quot;");
      return (
        '<img id="livechat__img" src="' +
        src +
        '" title="' +
        title +
        '" alt="' +
        title +
        '" />'
      );
    },

    createFile: function (name, url) {
      if (url.search("blob:") == -1) {
        url = chathubObject.getRootUrl() + url;
        url = url.replace(/([^:]\/)\/+/g, "$1");
      } else {
        url = url;
      }
      return (
        '<a target="_blank" style="color:#fff!important" href="' +
        url +
        '"><i class="material-icons" style="font-size:18px;margin-right:5px">get_app</i><span style="position:relative;top:-5px">' +
        name +
        "</span></a>"
      );
    },

    checkImage: function (url) {
      return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },

    convertTime: function (time, string = true) {
      var result = null;

      if (string) {
        time = String(time);
      }

      if (moment().format("MM/DD/YYYY") == moment(time).format("MM/DD/YYYY")) {
        result = moment(time).format("HH:mm");
      } else {
        result = moment(time).format("MM/DD/YYYY HH:mm");
      }

      return result;
    },

    containsKey: function (obj, key) {
      if (obj[key]) {
        return true;
      } else {
        return false;
      }
    },

    loadHistoryMessage: function () {
      var historyMessage = chathubObject.getHistoryMessage(
        this.token,
        this.room
      );
      var dataMessage = this.messages;
      var type = null;
      var convertTime = (time, string = true) => this.convertTime(time, string);
      var containsKey = (obj, key) => this.containsKey(obj, key);
      historyMessage
        .then((response) => {
          if (response.data.success) {
            var that = this;
            response.data.messages.reverse().forEach(function (value, key) {
              var revert = true;
              if (!value.t) {
                if (containsKey(value, "token")) {
                  revert = false;
                }
                var msg = value.msg;
                var title = "Title";

                if (value.attachments && value.attachments.lenght != 0) {
                  if (value.attachments[0].image_url) {
                    var imgSrc = value.attachments[0];
                    var imgCreateSrc =
                      "https://chathub.allchat.fpt.vn" + imgSrc.image_url;
                    var createImg = that.createImage(imgCreateSrc, title);
                    msg = createImg;
                    type = "image";
                  } else {
                    var createFile = that.createFile(
                      value.attachments[0].title,
                      value.attachments[0].title_link
                    );
                    msg = createFile;
                    type = "file";
                  }
                } else {
                  type = null;
                }
                if (revert) {
                  if (that.checkImage(msg)) {
                    msg = that.createImage(msg, title);
                  }
                  msg = msg.replace(/\n/gi, "");
                  if (msg != null && msg != "") {
                    dataMessage.push({
                      content: msg,
                      time: convertTime(value.ts),
                      revert: revert,
                      type: type,
                      agent: {
                        name: value.u.name,
                      },
                    });
                  }
                } else {
                  if (that.checkImage(msg)) {
                    msg = that.createImage(msg, title);
                  }
                  dataMessage.push({
                    content: msg,
                    type: type,
                    time: convertTime(value.ts),
                  });
                }
              }
              if (value.t == "livechat-close") {
                that.agentCloseChat();
              }
            });
          }
          this.history.ready = true;
        })
        .catch((error) => {
          this.$cookies.remove("fpt_livechat");
          this.$router.replace("/");
        });
    },

    checkCookie: function () {
      var token = null;
      var room = null;

      if (this.$cookies.isKey("fpt_livechat")) {
        token = this.$cookies.get("fpt_livechat").token;
        room = this.$cookies.get("fpt_livechat").room;
      }

      if (token != null && room != null) {
        this.token = token;
        this.room = room;
      } else {
        this.$router.replace("/");
      }
    },

    setting: function () {
      this.isSetting = !this.isSetting;
    },

    rename: function () {
      this.$router.replace("/rename");
    },

    confirmExit: function () {
      this.isSetting = false;
      this.cfmExit = true;
    },

    uploadImage: function () {
      this.$refs.uploadImageFile.click();
    },

    attachFile: function () {
      this.$refs.uploadAttachFile.click();
      // alert(this.$t("messages.comming"))
    },

    imagePreview: function (event) {
      var file = event.target.files;
      if (file.length > 0) {
        if (
          file[0].type == "image/png" ||
          file[0].type == "image/jpg" ||
          file[0].type == "image/jpeg" ||
          file[0].type == "image/gif"
        ) {
          var url = window.URL.createObjectURL(file[0]);
          var attachment = event.target.files[0];
          this.imagesData.push({ url: url, object: attachment });
        } else {
          alert(this.$t("validator.file.not_allowed"));
        }
      }
    },

    attachFilePreview: function (event) {
      var file = event.target.files;
      if (file.length > 0) {
        var ext = file[0].type;
        var size = file[0].size;

        if (size > validatorObject.maxFileSize()) {
          var sizeMb = validatorObject.maxFileSize() / 1000000 + "MB";
          alert(this.$t("validator.file.max_size", { size: sizeMb }));
          return false;
        }

        if (
          ext == "text/plain" ||
          ext == "application/pdf" ||
          ext ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          ext == "application/msword" ||
          ext == "video/mp4" ||
          ext == "videox-m4v" ||
          ext == "video/3gpp"
          // ext == 'application/vnd.ms-powerpoint' ||
          // ext == 'application/vnd.ms-excel' ||
          // ext == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          // ext == 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        ) {
          if (this.fileData.length < 1) {
            var url = window.URL.createObjectURL(file[0]);
            var attachment = event.target.files[0];
            this.fileData.push({ url: url, object: attachment });
          } else {
            alert(this.$t("validator.file.many"));
          }
        } else {
          alert(this.$t("validator.file.not_allowed"));
        }
      }
    },

    closeChatHandle: function (event) {
      this.$emit("parentCloseChat", true);
    },

    handlerReload: function (event) {
      if (!this.online) {
        this.$cookies.remove("fpt_livechat_offline");
      }
    },

    handerBackspace: function (event) {
      if (this.msg.length == 0) {
        this.imagesData.pop();
        this.$refs.uploadImageFile.value = "";

        if (this.imagesData.length == 0) {
          this.fileData.pop();
          this.$refs.uploadAttachFile.value = "";
        }
      }
    },

    onPasteClipboard: function (event) {
      var items = event.clipboardData || event.originalEvent.clipboardData;
      if (
        typeof items.items[0] !== "undefined" &&
        items.items[0] != null &&
        (items.items[0].type == "text/html" ||
          items.items[0].type == "image/png")
      ) {
        var url = window.URL.createObjectURL(items.files[0]);
        var attachment = items.files[0];
        this.imagesData.push({ url: url, object: attachment });
      }
    },

    handleRemoveImage: function (id) {
      this.imagesData.splice(id, 1);
      this.$refs.uploadImageFile.value = "";
    },

    handleRemoveFile: function () {
      this.fileData = [];
      this.$refs.uploadAttachFile.value = "";
    },

    checkWhiteSpace: function (event) {
      event.target.value = event.target.value.trimLeft();
    },

    agentCloseChat: function () {
      this.agentCloseChatVar = true;
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.userOnlineStatus = type === "online";
    },
  },

  created() {
    window.addEventListener("beforeunload", this.handlerReload);
    this.sso = this.$cookies.get("fpt_sso");
    if (this.sso) {
      this.gender = this.$t("messages.gender");
    } else {
      if (this.$cookies.isKey("fpt_gender")) {
        var genderOnline = this.$cookies.get("fpt_gender");
        if (genderOnline == 1) {
          this.gender = this.$t("messages.mr");
        } else {
          this.gender = this.$t("messages.ms");
        }
      }
    }

    if (this.$route.query.msg != "" && this.$route.query.msg != null) {
      this.msg = this.$route.query.msg;
      this.sendMessageOffline();
    }

    if (this.$cookies.isKey("fpt_livechat") && this.$cookies.isKey("fpt_sso")) {
      if (this.sso.contract != this.$cookies.get("fpt_livechat").contract) {
        this.$cookies.remove("fpt_livechat");
      }
    }

    Socket.init();
    if (this.$route.query.type == "offline") {
      if (!this.$cookies.isKey("fpt_livechat_offline")) {
        this.$router.replace("/");
      }
      this.online = false;
    } else {
      this.checkCookie();
    }
    this.loadHistoryMessage();
  },

  mounted() {
    Socket.$on("message", this.handleMessage);
    // var resultAgent = chathubObject.getAgentInfo(this.room, this.token);
    // var that = this
    // this.agentInfo.name = 's'
    // resultAgent.then(response => {
    //     that.agentInfo.name = response.data.agent.name
    // })

    // console.log(this.agentInfo)
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },

  beforeRouteLeave(to, from, next) {
    var closeSocket = new Promise(function (resolve, reject) {
      Socket.close(true);
      resolve("Success!");
    });
    closeSocket.then((response) => {
      next();
    });
  },
};
</script>
<style lang="scss" >
img#livechat__img {
  max-width: 100%;
  text-align: center;
}
</style>
<style lang="scss" module scoped>
.__chat {
  display: block;
  width: 100%;
  .__chat__content {
    height: 425px;
    background: #fff;
    position: relative;
    &.__expand {
      padding-bottom: 250px;
    }
  }
  .__chat__type {
    border-top: 1px solid #e5e5e5;
    .__chat__input {
      padding: 5px 15px 0;
      position: relative;
      .__chat__type__container {
        position: relative;
      }
      .__chat__area {
        border: 0px;
        width: 90%;
        outline: none;
        resize: none !important;
        line-height: 19px !important;
        font-size: 13px !important;
        background: none;
        overflow: auto !important;
        margin: 0;
        font-family: inherit;
      }
      .__chat__close {
        padding: 10px 0;
      }
      .__btn__send {
        position: absolute;
        right: 0px;
        top: calc(-10%);
        background: transparent;
        border: transparent;
        height: 38px;
        width: 38px;
        outline: none;
        i {
          color: #f36f21;
          font-size: 22px;
          line-height: 34px;
        }
      }
      textarea {
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
  .__chat__footer {
    width: 100%;
    height: 32px;
    display: table;
    padding: 0 15px 10px;
    .__icon__camera,
    .__icon__attach,
    .__icon__setting {
      display: table-cell;
      vertical-align: middle;
      width: 34px;
      float: left;
      cursor: pointer;
      text-decoration: none;
    }
    .__icon__camera,
    .__icon__attach {
      padding-right: 10px;
    }
    .__icon__camera,
    .__icon__setting {
      a {
        font-size: 20px !important;
      }
    }
    .__icon__setting {
      position: relative;
      text-align: right;
      float: right;
      width: auto;
      a {
        &.__active {
          color: #f37021 !important;
        }
      }
    }

    .__icon {
      color: #c7ccd1 !important;
      padding-top: 3px;
      text-decoration: none;
    }
    .__dropup__custom {
      display: none;
      position: absolute;
      list-style: none;
      top: -390% !important;
      right: 0px;
      background: #fff;
      width: 170px;
      padding: 0px !important;
      border: 0px !important;
      -webkit-box-shadow: -1px 1px 5px 0px #d6d6d6;
      -moz-box-shadow: -1px 1px 5px 0px #d6d6d6;
      box-shadow: -1px 1px 5px 0px #d6d6d6;
      &.__not__sso {
        top: -190% !important;
      }
      &.__active {
        display: block;
      }
      li {
        height: 47px;
        &:hover {
          a,
          .__icon {
            color: #f37021 !important;
          }
        }
        a {
          padding: 10px 15px 16px;
          display: table;
          font-size: 13px !important;
          font-weight: 410 !important;
          text-decoration: none;
          color: #323232 !important;
          text-decoration: none !important;
          span {
            display: table-cell;
            vertical-align: middle;
            line-height: 23px;
          }
          .__icon {
            width: 27px;
            color: #19abff !important;
            position: relative;
            top: -3px;
          }
        }
      }
    }
  }
  .__chat__message {
    list-style: none;
    overflow-x: auto;
    height: inherit;
    position: relative;
    margin: 0;
    padding: 0;
    padding-top: 20px;
    &::-webkit-scrollbar-track {
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 5px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #d8d8d8;
    }
    &.__error {
      li {
        &:last-child {
          margin-bottom: 40px !important;
        }
      }
    }
    li {
      width: calc(80% - 36px);
      &.__welcome {
        width: calc(100% - 36px);
        h5 {
          font-size: 15px !important;
          margin-bottom: 5px !important;
          line-height: 150% !important;
        }
      }
      float: right;
      margin-bottom: 15px;
      margin-right: 20px;
      &.__revert {
        width: calc(90% - 36px);
        float: left;
        margin-left: 20px;

        .__chat__time {
          text-align: left;
        }
        .__chat__item {
          background: #f1f0f0;
          color: #333 !important;
          float: left;
          div {
            color: inherit !important;
          }
        }
      }
    }
    .__chat__time {
      text-align: right;
      padding-bottom: 5px;
      color: #9a9a9a;
      font-size: 11px;
      font-weight: 500;
    }
    .__chat__item {
      word-break: keep-all;
      background: #f37021;
      border-radius: 6px;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      color: #fff !important;
      padding: 10px;
      width: fit-content;
      float: right;
      font: 400 13px/15px "Roboto", sans-serif;
      div {
        color: inherit !important;
      }
      &.__image__box {
        background: none !important;
        text-align: right;
        padding-left: 0;
        padding-right: 0;
      }
    }
    .__chat__avatar {
      img {
        width: 25px;
        border-radius: 50%;
      }
    }
    .__chat__left {
      margin-left: 0px;
      .__prefix {
        margin-top: 3px;
        font-size: 9px;
      }
    }
  }
  .__success__message,
  .__error__message {
    position: absolute;
    bottom: 0px;
    width: 100%;
    background: #fff;
    display: block;
    text-align: center;
    padding: 8px 0;
    .__text {
      display: inline;
      padding-left: 5px;
      color: #9a9a9a;
      font-size: 12px;
      line-height: 12px;
    }
  }
  .__error__message {
    .__text {
      span {
        font-size: 14px;
        position: relative;
        top: 2px;
      }
      color: #dc3545;
    }
  }
}
@media screen and (min-width: 769px) {
  .__chat {
    .__chat__content {
      height: 225px;
    }
    .__chat__footer {
      .__icon__camera,
      .__icon__attach,
      .__icon__setting {
        a {
          &:hover {
            color: #f37021 !important;
          }
        }
      }
    }
  }
}
</style>